import { render } from "./OldLogin.vue?vue&type=template&id=c72e2c0c"
import script from "./OldLogin.vue?vue&type=script&lang=js"
export * from "./OldLogin.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__